import { useMutation } from 'react-query';
import fundingRequests from 'services/api/fundingRequests';
import useTranslation from 'utils/hooks/useTranslation';
import notify from 'utils/notificationUtils';
import useAmplitude from 'utils/hooks/useAmplitude';
import { AMPLITUDE_EVENT_TYPES } from 'constants/amplitude';

export const useApproveFundingRequest = () => {
  const { translateText } = useTranslation();
  const { sendAmplitudeEvent } = useAmplitude();

  return useMutation({
    mutationFn: async ({ id, note }) => {
      const result = await fundingRequests.approve({ id, note });
      return result?.data;
    },
    onSuccess: () => {
      notify({
        type: 'success',
        message: translateText('corporateAccounts.fundingRequests.reviewModal.approveSuccess'),
      });
      sendAmplitudeEvent(AMPLITUDE_EVENT_TYPES.fundingRequestApproveSuccessful);
    },
    onError: () => {
      notify({
        type: 'error',
        message: translateText('corporateAccounts.fundingRequests.reviewModal.approveError'),
      });
      sendAmplitudeEvent(AMPLITUDE_EVENT_TYPES.fundingRequestApproveFailed);
    },
  });
};

export const useDeclineFundingRequest = () => {
  const { translateText } = useTranslation();
  const { sendAmplitudeEvent } = useAmplitude();

  return useMutation({
    mutationFn: async ({ id, note }) => {
      const result = await fundingRequests.decline({ id, note });
      return result?.data;
    },
    onSuccess: () => {
      notify({
        type: 'success',
        message: translateText('corporateAccounts.fundingRequests.reviewModal.declineSuccess'),
      });
      sendAmplitudeEvent(AMPLITUDE_EVENT_TYPES.fundingRequestDeclineSuccessful);
    },
    onError: () => {
      notify({
        type: 'error',
        message: translateText('corporateAccounts.fundingRequests.reviewModal.declineError'),
      });
      sendAmplitudeEvent(AMPLITUDE_EVENT_TYPES.fundingRequestDeclineFailed);
    },
  });
};

export default { useApproveFundingRequest, useDeclineFundingRequest };
